import type { CreateContractApi, NewContract } from '../../models';

const toNumberKey = (id: string | number | null | undefined): number | null => {
  if (id === null || id === undefined || id === '') {
    return null;
  }

  const key = Number(id);

  return Number.isNaN(key) ? null : key;
};

const toStringCode = (id: string | number | null | undefined): string | null =>
  id === null || id === undefined || id === '' ? null : String(id);

export const normalizeCreateContract = (values: NewContract): CreateContractApi => ({
  cargoType: toStringCode(values.cargoType?.id),
  carrierKey: toNumberKey(values.carrier?.id),
  customerId: toNumberKey(values.customer?.id),
  customerLaneId: toNumberKey(values.customerLaneId?.id),
  effectiveFrom: values.effectiveFrom ?? null,
  effectiveTo: values.effectiveTo ?? null,
  name: values.name,
  pricingBasis: toStringCode(values.pricingBasis?.id),
  pricingCategory: toStringCode(values.pricingCategory?.id),
  pricingType: toStringCode(values.pricingType?.id),
  primaryDocumentKey: values.primaryDocumentKey ?? null,
  serviceLayer: toStringCode(values.serviceLayer?.id),
  status: values.status ?? null,
  supplierDiversity: toStringCode(values.supplierDiversity?.id),
  trailerKey: toNumberKey(values.trailer?.id),
  transportationMode: toStringCode(values.transportationMode?.id),
  uniqueName: values.uniqueName,
});
